import React, { Component } from "react";

function ordinalSuffix(n) {
    const mod100 = n % 100;
    if (mod100 >= 11 && mod100 <= 13) return "th";
    switch (n % 10) {
        case 1:
            return "st";
        case 2:
            return "nd";
        case 3:
            return "rd";
        default:
            return "th";
    }
}

function parseDateString(str) {
    const sep = str.includes("-") ? "-" : str.includes("/") ? "/" : null;
    if (!sep) return null;
    const parts = str.split(sep);
    if (parts.length !== 3) return null;
    let y, m, d;
    if (parts[0].length === 4) {
        y = +parts[0];
        m = +parts[1];
        d = +parts[2];
    } else if (parts[2].length === 4) {
        y = +parts[2];
        m = +parts[0];
        d = +parts[1];
    } else {
        return null;
    }
    return new Date(y, m - 1, d);
}

const pad = (n) => String(n).padStart(2, "0");

function fmtDate(str, format) {
    const dt = parseDateString(str);
    if (!dt || isNaN(dt.getTime())) return str;
    const Y = dt.getFullYear();
    const M = pad(dt.getMonth() + 1);
    const D = pad(dt.getDate());
    return format.replace("YYYY", Y).replace("MM", M).replace("DD", D);
}

function extractWeekdays(rec) {
    const map = [
        ["checkedMonday", "Monday"],
        ["checkedTuesday", "Tuesday"],
        ["checkedWednesday", "Wednesday"],
        ["checkedThursday", "Thursday"],
        ["checkedFriday", "Friday"],
        ["checkedSaturday", "Saturday"],
        ["checkedSunday", "Sunday"],
    ];
    return map.filter(([k]) => rec[k]).map(([, v]) => v);
}

function capitalize(str) {
    return str ? str[0].toUpperCase() + str.slice(1) : "";
}

function frequencyText(data, lang) {

    let chosenDate = ''
    if (data == '1') {
        chosenDate = `1${'st'.translate(lang)}`;
    } else if (data == '2') {
        chosenDate = `2${'nd'.translate(lang)}`
    } else if (data == '3') {
        chosenDate = `3${'rd'.translate(lang)}`
    } else if (/^[2-9][1]$/.test(data)) {
        chosenDate = data + 'st'.translate(lang)
    } else if (/^[2-9][2]$/.test(data)) {
        chosenDate = data + 'nd'.translate(lang)
    } else if (/^[2-9][3]$/.test(data)) {
        chosenDate = data + 'rd'.translate(lang)
    } else if (data) {
        chosenDate = data + 'th'.translate(lang)
    }


    return chosenDate
}

function buildRecurringText(recurringObj, lang, dateFormat) {
    if (!recurringObj || !recurringObj.frequencyType) return "";
    const { frequencyType } = recurringObj;
    const start =
        recurringObj[`${"frequency" + capitalize(frequencyType)}ScheduledDateFrom`];
    const end =
        recurringObj[`${"frequency" + capitalize(frequencyType)}ScheduledDateTo`];

    switch (frequencyType) {
        case "day": {
            const n = Number(recurringObj.frequencyDayText || 1);
            if (n === 1)
                return `${"This event is scheduled every day".translate(
                    lang
                )}, ${"between".translate(lang)} ${fmtDate(
                    start,
                    dateFormat
                )} - ${fmtDate(end, dateFormat)}.`;
            if (n === 2)
                return `${"This event is scheduled every other day".translate(
                    lang
                )}, ${"between".translate(lang)} ${fmtDate(
                    start,
                    dateFormat
                )} - ${fmtDate(end, dateFormat)}.`;
            return `${"This event is scheduled every1".translate(
                lang
            )} ${n}${ordinalSuffix(n)?.translate(lang)} ${"day".translate(lang)}, ${"between".translate(
                lang
            )} ${fmtDate(start, dateFormat)} - ${fmtDate(end, dateFormat)}.`;
        }

        case "week": {
            let days = extractWeekdays(recurringObj);
            days = days.map((d) => d.translate(lang));
            if (!days.length) return "";
            let list;
            if (days.length === 1) list = days[0];
            else if (days.length === 2) list = `${days[0]} & ${days[1]}`;
            else list = days.slice(0, -1).join(", ") + ` & ${days[days.length - 1]}`;
            return `${"This event is scheduled every2".translate(
                lang
            )} ${list}, ${"between".translate(lang)} ${fmtDate(
                start,
                dateFormat
            )} - ${fmtDate(end, dateFormat)}.`;
        }

        case "month": {
            const dayOfMonth = recurringObj.frequencyMonthScheduled;
            return `${"This event is scheduled once a month".translate(
                lang
            )} (${frequencyText(dayOfMonth, lang)}), ${"between".translate(lang)} ${fmtDate(
                start,
                dateFormat
            )} - ${fmtDate(end, dateFormat)}.`;
        }

        default:
            return "";
    }
}

class RecurringDescription extends Component {
    render() {
        const recurringObj = this.props.data?.recurringObj;

        const {
            // className = "",
            lang = "se",
            dateFormat = "YYYY-MM-DD",
        } = this.props;
        const text = buildRecurringText(recurringObj, lang, dateFormat);
        return <div className='info-message-update-wrap'>{text}</div>;
    }
}

export default RecurringDescription;
